<!--
 * @Author: your name
 * @Date: 2020-11-03 16:04:18
 * @LastEditTime: 2021-03-24 14:13:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\pages\index.vue
-->

<template>
  <div class="index-page">
    <Head />
    <Swiper :swiperBanner="swiperBanner" />
    <!-- <Cert :certList="certList" /> -->
    <Assoc :association="association" />
    <Train :trainList="trainList" />
    <News :newsList="newsList" />
    <!-- <Expert  :expertList="expertList"/> -->
    <Partners :partnersList="classList" :type="'class'"/>
    <Partners :partnersList="partnersList" :type="'org'"/>
   
    <Bindtel v-if="isShow" />
    <Footer />
    <Animation v-if="floatBanner.length > 0" :floatBanner="floatBanner" />
    <TipModal :visible.sync="visible"></TipModal>
  </div>
</template>

<script>
import Head from "./../components/public/head";
import Footer from "./../components/public/footer";
import Swiper from "./../components/index/swiper";
import Cert from "./../components/index/certificate";
import Assoc from "./../components/index/association";
import News from "./../components/index/news";
import Train from "./../components/index/train";
import Animation from "./../components/index/animation";
import Expert from "./../components/index/expert";
import Partners from "./../components/index/partners";
import Service from "./../components/public/service";
import Bindtel from "./../components/login/bindTel";
import TipModal from "./../components/index/TipModal";
import { getHomeApi } from "./../api/api";
export default {
  metaInfo: {
    title: "首页-人工智能职业技能等级认证学习平台（AIOC）官方网站"
  },
  components: {
    Head,
    Footer,
    Swiper,
    Cert,
    News,
    Assoc,
    Train,
    Expert,
    Partners,
    Service,
    Bindtel,
    Animation,
    TipModal
  },
  data() {
    return {
      swiperBanner: [],
      certList: [],
      association: [],
      newsList: [],
      expertList: [],
      trainList: [],
      partnersList: [],
      isShow: null,
      floatBanner: [],
      visible: false,
      classList:  []
    };
  },
  beforeCreate() {
    if (this.$route.query && this.$route.query.lang) {
      if (this.$route.query.lang === "cht") {
        localStorage.setItem("lang", "cht");
      } else {
        localStorage.setItem("lang", "ch");
      }
    }
    this.$zh_tran(localStorage.getItem("lang"));
    // if(this.$route.query.lang === 'cht') {
    //   localStorage.setItem('lang', 'cht')
    // } else {
    //   localStorage.setItem('lang', 'ch')
    // }
  },
  created() {
    if (
      window.localStorage.getItem("mobileStatus") == 2 &&
      window.localStorage.getItem("flag") == 1
    ) {
      this.isShow = true;
    }
    this.GetHomeInfo();
    // console.log('lang', localStorage.getItem('lang'))
  },
  mounted() {
    this.$zh_tran();
  },
  methods: {
    /**
     * @description: 获取首页数据
     * @param {object} swiperBanner - Banner图列表
     * @param {object} certList - 在线课堂
     * @param {object} association - 认证介绍
     * @param {object} trainList - 实训基地
     * @param {object} newsList - 行业资讯列表
     * @param {object} partnersList - 合作机构列表
     */
    GetHomeInfo() {
      getHomeApi({ lang: localStorage.getItem("lang") }).then(res => {
        const {
          bannerList,
          certList,
          courseList,
          trainList,
          newsList,
          orgList,
          expertList,
          floatBanner,
          classOrg
        } = res.data.data;
        this.swiperBanner = bannerList;
        this.association = courseList;
        this.certList = certList;
        this.trainList = trainList;
        this.newsList = newsList;
        this.expertList = expertList;
        this.partnersList = orgList;
        this.floatBanner = floatBanner;
        this.classList = classOrg
        if (res.data.data.is_tip === 0) {
          this.visible = true;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
div.index-page {
  background-color: rgb(245, 245, 245);
  background-image: url(./../assets/image/bg.png);
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue